// Общие модули сайта

import initForms from './Forms/index';
import initLazyImage from './LazyImage/index';
import initLightbox from './Lightbox/index';
import initMainMenu from './MainMenu/index';
import initOnlineOffice from './OnlineOffice/index';
import {saveUTMTags} from './UTMTags';
import {initVideoContainer} from './Video/index';

/**
 * Общие модули сайта
 */
function main(): void
{
	initMainMenu();
	initForms();
	initLazyImage();
	initLightbox();
	initOnlineOffice();
	initVideoContainer();
	saveUTMTags();
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/index.ts